import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/daily/$lobbyId")({
  loader: () => {
    throw redirect({ to: "/daily" });
  },
});
